module.exports = __webpack_public_path__ + "img/LUB00104.086e7ec6.png";